import { applyDateRangeFilter } from '$app/shared/components/DateRangeFilter';

export const applySegmentFilter = (booking, filteredSegment) => {
  if (!filteredSegment || filteredSegment === 'all') return true;
  if (filteredSegment === booking.segment) return true;
  return false;
};

export const applyStatusFilter = (booking, filteredStatus) => {
  if (!filteredStatus || filteredStatus === 'all') return true;
  if (filteredStatus === booking.masterStatus.masterStatusName) return true;
  return false;
};

export const applyGarageFilter = (booking, filteredGarage) => {
  if (!filteredGarage) return true;
  const stringifiedBooking = JSON.stringify(booking);
  return stringifiedBooking.includes(filteredGarage);
};

export const applyCndTypeFilter = (booking, filteredCndType) => {
  if (!filteredCndType || filteredCndType === 'allCndTypes') return true;
  return booking.collectionDeliveryOption === filteredCndType;
};

export const applyUserSelectedFilters = (bookings, filters) => {
  const { filteredSegment, filteredDateRange, filteredGarage, filteredCndType, filteredStatus } = filters;
  return bookings.filter(
    (booking) =>
      applySegmentFilter(booking, filteredSegment) &&
      applyDateRangeFilter(booking, filteredDateRange) &&
      applyGarageFilter(booking, filteredGarage) &&
      applyStatusFilter(booking, filteredStatus) &&
      applyCndTypeFilter(booking, filteredCndType)
  );
};
